export default function ShoppingBasket(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip-shopping-basket)">
				<path
					d="M24.3506 9.94775H3.64555C3.33411 9.97123 3.03167 10.063 2.75969 10.2165C2.48771 10.37 2.25286 10.5816 2.07183 10.8361C1.88729 11.0919 1.75994 11.3844 1.69844 11.6938C1.63695 12.0032 1.64273 12.3222 1.71541 12.6291L3.87859 24.5362C3.93956 25.0167 4.16648 25.4608 4.52014 25.7918C4.87137 26.1208 5.32808 26.3141 5.80872 26.3374H22.1929C22.6737 26.3146 23.1305 26.1212 23.4815 25.7918C23.8341 25.4604 24.0601 25.0163 24.1203 24.5362L26.278 12.6154C26.3474 12.3097 26.351 11.9927 26.2886 11.6855C26.2262 11.3782 26.0992 11.0878 25.9161 10.8333C25.7341 10.5819 25.5 10.3727 25.2299 10.2199C24.9597 10.0671 24.6598 9.97425 24.3506 9.94775Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.9219 1.66235L21.8425 9.94767"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6.16406 9.94767L10.0846 1.66235"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip-shopping-basket">
					<rect width="28" height="28" fill="currentColor" />
				</clipPath>
			</defs>
		</svg>
	)
}
